import type { Address } from 'viem';

import type { ParseWeiFormatOptions } from '@shared/helpers/web3/formatters';
import { parseWei } from '@shared/helpers/web3/formatters';
import type { Web3Handle } from '@shared/helpers/web3/handle';

import type { TokenInfoWithBalance } from './types';
import { useTokenBalance } from './useTokenBalance';
import { useTokenInfo } from './useTokenInfo';

type UseTokenInfoWithBalanceProps = Partial<Web3Handle> & {
  walletAddress?: Address;
};

type UseTokenInfoWithBalanceOptions = {
  formatOptions?: ParseWeiFormatOptions;
  enabled?: boolean;
};

export const useTokenInfoWithBalance = (
  props?: UseTokenInfoWithBalanceProps,
  options?: UseTokenInfoWithBalanceOptions,
) => {
  const { formatOptions } = options ?? {};
  const { data: tokenInfo, isLoading: isTokenInfoLoading } = useTokenInfo(props, options);

  const {
    data: tokenBalance,
    isLoading: isTokenBalanceLoading,
    refetch,
  } = useTokenBalance(props, options);

  const resultData: TokenInfoWithBalance | undefined = tokenInfo
    ? {
        ...tokenInfo,
        balance: parseWei({
          wei: tokenBalance ?? BigInt(0),
          decimals: tokenInfo.decimals,
          symbol: tokenInfo.symbol,
          formatOptions,
        }),
      }
    : undefined;

  return {
    isLoading: isTokenInfoLoading || isTokenBalanceLoading,
    data: resultData,
    refetch,
  };
};
